// components
import BrandList from "./BrandList/BrandList";
// images
import carRepair from "../../../assets/images/carRepair.png";
import heroVector from "../../../assets/images/heroVector.png";

// react router
import { Link } from "react-router-dom";

const Welcome = () => {
  // know more button handler

  return (
    <section className="relative h-960" id="welcome">
      <div className="bg-welcome-shape bg-no-repeat bg-cover w-10/12 sm:w-2/3 xl:w-976 h-800 absolute z-0">
        <div className="absolute top-8 md:top-204 right-2 sm:right-10 w-10/12 md:w-2/3">
          <h1 className="mb-12 text-white text-xl sm:text-6xl">
            اشتري كل اللي عربيتك محتاجاه مع موتور
          </h1>
          <Link to="/#whyMtor" className="p-2 sm:p-4 bg-white rounded text-3xl">
            إعرف أكتر عن موتور
          </Link>
        </div>
      </div>

      <img
        src={carRepair}
        alt="mechanic repairs a car"
        className="absolute left-0 top-44 xl:top-30 2xl:top-20 w-1/2 min-w-1/2"
      />

      <img
        src={heroVector}
        alt="vector"
        className="w-screen absolute right-0 z-20 bottom-1/2 sm:bottom-96"
      />

      <div className="absolute bottom-1 sm:-bottom-20 left-2 md:left-14 right-2 md:right-14  z-20 flex flex-col items-center justify-center gap-y-9 bg-light-blue rounded-3xl overflow-hidden">
        <h2 className="mt-16 text-center text-4xl">أختر من اشهر الماركات</h2>
        <BrandList />
      </div>
    </section>
  );
};

export default Welcome;
